import one from '@mailobj-browser/front/js/selectors/one.js'

export default input => {
  const { form: mainForm } = input

  if (mainForm) {
    const mainAttachLinks = one('[type="hidden"][name="msg_attach_links"]', mainForm)

    if (mainAttachLinks) {
      if (mainAttachLinks.value === '1') {
        input.value = mainAttachLinks.value
      } else {
        input.value = '0'
      }
    }
  }
}
